
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/procesos",
      function () {
        return require("private-next-pages/procesos/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/procesos"])
      });
    }
  